const Promotion = () => {
  return (
    <div>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.0404 4.95954C11.1427 5.06182 11.1427 5.22763 11.0404 5.32991C10.9381 5.43218 10.7723 5.43218 10.67 5.32991C10.5677 5.22763 10.5677 5.06182 10.67 4.95954C10.7723 4.85727 10.9381 4.85727 11.0404 4.95954"
          stroke="white"
          strokeWidth="1.1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.42017 2H12.5155C13.3358 2 14 2.66425 14 3.48379V6.57913C14 6.97301 13.8433 7.34996 13.5652 7.62879L7.62861 13.5653C7.04907 14.1449 6.10953 14.1449 5.52999 13.5653L2.43465 10.47C1.85512 9.89047 1.85512 8.95093 2.43465 8.37139L8.37121 2.43483C8.64933 2.15671 9.02699 2 9.42017 2Z"
          stroke="white"
          strokeWidth="1.1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.98334 6.82828L9.17165 12.0166"
          stroke="white"
          strokeWidth="1.1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default Promotion;
